var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "summary main" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.title))]),
      _c("omegaup-markdown", { attrs: { markdown: _vm.eventDescription } }),
      _vm.finishTime !== null
        ? _c(
            "table",
            { staticClass: "table table-bordered mx-auto w-50 mb-0" },
            [
              _vm.showDeadlines
                ? _c("tr", [
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.T.arenaPracticeStartTime))
                      ])
                    ]),
                    _c("td", [
                      _vm._v(_vm._s(_vm.time.formatTimestamp(_vm.startTime)))
                    ])
                  ])
                : _vm._e(),
              _vm.showDeadlines
                ? _c("tr", [
                    _c("td", [
                      _c("strong", [_vm._v(_vm._s(_vm.T.arenaPracticeEndtime))])
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.finishTime
                              ? _vm.time.formatTimestamp(_vm.finishTime)
                              : _vm.T.wordsUnlimitedDuration
                          ) +
                          " "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.showRanking &&
              typeof _vm.scoreboard === "number" &&
              _vm.duration != Infinity
                ? _c("tr", [
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.T.arenaPracticeScoreboardCutoff))
                      ])
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.time.formatTimestamp(
                              new Date(
                                _vm.starTime.getTime() +
                                  (_vm.duration * _vm.scoreboard) / 100
                              )
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                : _vm._e(),
              _c("tr", [
                _c("td", [
                  _c("strong", [_vm._v(_vm._s(_vm.T.arenaContestWindowLength))])
                ]),
                _c("td", [_vm._v(_vm._s(_vm.eventWindowLength))])
              ]),
              _c("tr", [
                _c("td", [
                  _c("strong", [_vm._v(_vm._s(_vm.T.arenaContestOrganizer))])
                ]),
                _c("td", [
                  _c("a", { attrs: { href: "/profile/" + _vm.admin + "/" } }, [
                    _vm._v(_vm._s(_vm.admin))
                  ])
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }